import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { ArrowLeft, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { StepNav } from '@/components/verification/step-nav';
import { FlowCancelConfirmDialog } from '@/components/verification/flow-cancel-dialog';
import { ROUTES } from '@/lib/constants';
import { useCandidateVerificationStore } from '@/features/verification/store';

const STEPS = [
  { to: ROUTES.candidateVerificationPricing, label: 'Pricing' },
  { to: ROUTES.candidateVerificationOtp, label: 'Verify identity' },
  { to: ROUTES.candidateVerificationRecords, label: 'Choose records' },
  { to: ROUTES.candidateVerificationConsent, label: 'Consent' },
  { to: ROUTES.candidateVerificationConfirm, label: 'Confirm' },
];

export function CandidateVerificationLayout() {
  const reset = useCandidateVerificationStore((s) => s.reset);
  const navigate = useNavigate();
  const [cancelOpen, setCancelOpen] = useState(false);
  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <div className="flex items-center justify-between">
        <Button variant="ghost" size="sm" onClick={() => navigate(ROUTES.dashboard)}>
          <ArrowLeft className="h-4 w-4" /> Back
        </Button>
        <Button variant="ghost" size="sm" onClick={() => setCancelOpen(true)}>
          Cancel <X className="h-4 w-4" />
        </Button>
      </div>

      <StepNav steps={STEPS} />

      <Card className="p-6 sm:p-8">
        <Outlet />
      </Card>

      <FlowCancelConfirmDialog
        open={cancelOpen}
        onStay={() => setCancelOpen(false)}
        onConfirmCancel={() => {
          setCancelOpen(false);
          reset();
          navigate(ROUTES.dashboard, { replace: true });
        }}
        description="This will abandon your verification and clear the records, signature and progress you've selected."
      />
    </div>
  );
}
